"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFlowAccountConfiguration = void 0;
const tslib_1 = require("tslib");
const react_1 = require("react");
const fcl = tslib_1.__importStar(require("@onflow/fcl"));
const useFlowUser_1 = require("./useFlowUser");
const useContractCadence_1 = require("./useContractCadence");
function useFlowAccountConfiguration(addressProps) {
    const flowUser = (0, useFlowUser_1.useFlowUser)();
    const [configured, setConfigured] = (0, react_1.useState)(false);
    const [isConfiguring, setIsConfiguring] = (0, react_1.useState)(false);
    const { isAccountConfigured_script, configureAccount_transaction, isLoading: isContractLoading, } = (0, useContractCadence_1.useContractCadence)(addressProps);
    // A callback that runs a transaction against the user account to initialize it
    const configure = (0, react_1.useCallback)(async () => {
        try {
            setIsConfiguring(true);
            const txId = await fcl.mutate({
                cadence: configureAccount_transaction,
                limit: 9999,
            });
            await fcl.tx(txId).onceSealed();
        }
        finally {
            setIsConfiguring(false);
        }
    }, [configureAccount_transaction]);
    // When configuration transaction completes, check if the account is configured
    (0, react_1.useEffect)(() => {
        (async function () {
            if (isConfiguring || !(flowUser === null || flowUser === void 0 ? void 0 : flowUser.addr) || !isAccountConfigured_script) {
                return;
            }
            const result = await fcl.query({
                cadence: isAccountConfigured_script,
                args: (arg, t) => [arg(flowUser.addr, t.Address)],
            });
            setConfigured(result);
        })();
    }, [flowUser === null || flowUser === void 0 ? void 0 : flowUser.addr, isConfiguring, isAccountConfigured_script]);
    const isLoading = isContractLoading || isConfiguring;
    return {
        configured,
        configure,
        isLoading,
    };
}
exports.useFlowAccountConfiguration = useFlowAccountConfiguration;
